var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_366_35361)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.668 2.31262C24.5828 -0.770874 19.5644 -0.770874 16.4792 2.31262L9.95619 8.83563L17.3621 16.2415C18.8863 14.9722 20.8188 14.1774 22.9526 14.1774C24.1765 14.1774 25.3412 14.4317 26.4009 14.8857L27.668 13.5014C30.7523 10.4171 30.7523 5.39788 27.668 2.31262ZM16.1293 17.4948L8.71312 10.0786L2.32886 16.4692C-0.755454 19.5535 -0.755454 24.5727 2.32886 27.6579C5.414 30.7413 10.491 30.8001 13.5762 27.7165L14.8704 26.416C14.4165 25.3563 14.1622 24.1916 14.1622 22.9677C14.1623 20.8887 14.9181 19.0015 16.1293 17.4948ZM15.9203 22.9678C15.9203 26.5505 18.6094 29.4743 22.0735 29.9114V16.0241C18.6094 16.4612 15.9203 19.385 15.9203 22.9678ZM23.8316 16.0241V29.9114C27.2958 29.4743 29.9848 26.5505 29.9848 22.9677C29.9848 19.385 27.2958 16.4612 23.8316 16.0241Z",
    fill: "#6045EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_366_35361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescriptionIcon);
export default __webpack_public_path__ + "static/media/prescription-icon.9deb607e38b40805d4c45ea9040ced31.svg";
export { ForwardRef as ReactComponent };